import { copy } from 'clipboard';

interface shareContent {
	title?: string; // title经常被某些浏览器省略
	text?: string;
	url: string;
	imageUrl?: string;
}

/**
 * navigate.share + 复制链接分享
 * @param shareContent
 */
export const navigateShare = async (shareContent: shareContent) => {
	const documentTitle = document.title;
	const {
		title = documentTitle,
		text = documentTitle,
		url = 'https://a1.art',
		imageUrl = '',
	} = shareContent;
	if (shareContent.imageUrl && navigator?.canShare?.(shareContent) && navigator?.share) {
		const isVideo = imageUrl.endsWith('.mp4');
		const file = new File(
			[await fetch(imageUrl).then((r) => r.blob())],
			isVideo ? 'audio.mp4' : 'image.jpg',
			{ type: isVideo ? 'video/mp4' : 'image/jpeg' },
		);

		await navigator.share({ url, title, text, files: [file] }).catch(() => {
			// 这里一般都是用户取消分享，走复制逻辑比较好
			// ToastV2.error('Network issue detected. Please try again later.')
			console.log('复制', url);
			copy(url);
		});
	} else {
		copy(url);
	}
};

export const onlyCopyLink = async (url = 'https://a1.art') => {
	copy(url);
};
